
import reducer from './reducer'

import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage';

import { getNameForSessionAndStore } from '../src/actions/system/util'


function baseUrl() {
    /*
    let p = window.location.href;

    let urlType = 0;
    if(p.indexOf('localhost') > -1) {
        //localhost for development
        urlType = 1;
        p = ('localhost');
    } else if (p.indexOf('teamware.cloud') > -1) {
        //a teamware sub-url ... only the first sub-path will be supported
        urlType = 2;

        p = window.location.origin;
        const firstPath = window.location.pathname.split('/')[1];
        p = p.concat('/').concat(firstPath);
    } else {
        //a customer specific domain will be used
        urlType = 3;

        p = window.location.origin;        
    };

    p = p.concat('_store');

    console.log('store value => ', p);
    */
    
    return getNameForSessionAndStore('store');
}

const persistConfig = {
    //key: 'persistedReducer', 
    key: baseUrl(),
    storage: storage
}

const persistedReducer = persistReducer(persistConfig, reducer)

const store = createStore(persistedReducer, applyMiddleware(thunkMiddleware))

let persistor = persistStore(store)

//console.log('Hallo Alex *****************///////////////*************', window.location.href, window.location.pathname, window.location);
//console.log('Hallo Alex ***************** origin *************', window.location.origin);

export {store, persistor}
